// extracted by css-extract-rspack-plugin
export default {"footer":"src-shared-components-PublicFooter-PublicFooter-module__footer-G1aEEP","button":"src-shared-components-PublicFooter-PublicFooter-module__button-YNry5Y"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"footer\":\"src-shared-components-PublicFooter-PublicFooter-module__footer-G1aEEP\",\"button\":\"src-shared-components-PublicFooter-PublicFooter-module__button-YNry5Y\"}";
        // 1793875567208
        var cssReload = require("../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  